import React, { useEffect, useState } from 'react';
import Project from './Project';

const Projects = () => {
    const [projects , setProjects] = useState([]);
    useEffect(() => {
        fetch('https://nameless-inlet-82979.herokuapp.com/projects')
        .then(res => res.json())
        .then(data => setProjects(data))
    }, [])
    return (
        <div id='projects' className='p-12'>
            <h1 className='text-4xl font-bold text-primary text-center py-6'>My Projects</h1>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
            {
                projects.map(project => <Project
                key={project._id}
                project = {project} 

                ></Project>)
            }
            </div>
        </div>
    );
};

export default Projects;